

const breakPoints = {

    /**
     * Matches breakpoints set in WP theme _variables.scss
     */
    breakpoints: {
        xs: 0,
        sm: 576,
        md: 748,
        lg: 992,
        xl: 1200,
    },

    max: (bp) => {
        if( ! this.breakpoints.hasOwnProperty(bp) ) return null
        return window.outerHeight <= this.breakpoints[bp]
    },
    min: (bp) => {
        if( ! this.breakpoints.hasOwnProperty(bp) ) return null
        return window.outerHeight >= this.breakpoints[bp]
    },

    sm: () => {
        return window.outerHeight <= this.breakpoints.sm
    },
    md: () => {
        return  window.outerHeight <= this.breakpoints.md &&
                window.outerHeight > this.breakpoints.sm
    },
    lg: () => {
        return  window.outerHeight <= this.breakpoints.lg &&
                window.outerHeight > this.breakpoints.md
    },
    xl: () => {
        return  window.outerHeight <= this.breakpoints.xl &&
                window.outerHeight > this.breakpoints.lg
    }
}

export default breakPoints